export const BARREL_CARD_WIDTH = 272; // px
export const BARREL_CARD_HEIGHT = 202; // px
export const BARREL_CARD_THUMBNAIL_WIDTH = 272; // px
export const BARREL_CARD_THUMBNAIL_HEIGHT = 148; // px
